import type { ProfilingDataDto } from '../dto';
import type { ProfilingData } from '../models';

export const mapProfilingDataDtoToModel = (
  dto: ProfilingDataDto,
): ProfilingData => ({
  ...dto,
  profileDescription:
    dto.cveProfileDescription ?? dto.calculatedProfile ?? '',
});
